import { render, staticRenderFns } from "./Telnyx.vue?vue&type=template&id=c6ec2474&"
import script from "./Telnyx.vue?vue&type=script&lang=js&"
export * from "./Telnyx.vue?vue&type=script&lang=js&"
import style0 from "./Telnyx.vue?vue&type=style&index=0&id=c6ec2474&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports